<template>
  <div>
    <form>
      <div class="row">
        <div class="col-md-12 col-lg-5">
          <label for="name" class="form-label">Supplier Name:</label>

          <input
            class="form-control"
            type="text"
            size="35"
            name="name"
            v-model="form.name"
          />

          <label for="contact" class="form-label">Main contact:</label>
          <input
            class="form-control"
            type="text"
            name="contact"
            v-model="form.contact"
          />

          <label for="accountnum" class="form-label">Account #:</label>
          <input
            class="form-control"
            type="text"
            name="accountnum"
            v-model="form.accountnum"
          />

          <label for="address1" class="form-label">Address 1:</label>
          <input
            class="form-control"
            type="text"
            name="address1"
            v-model="form.address1"
          />

          <label for="address2" class="form-label">Address 2:</label>
          <input
            class="form-control"
            type="text"
            name="address2"
            v-model="form.address2"
          />

          <label for="city" class="form-label">City:</label>
          <input
            class="form-control"
            type="text"
            name="city"
            v-model="form.city"
          />

          <label for="state" class="form-label">State:</label>
          <input
            class="form-control"
            type="text"
            name="state"
            v-model="form.state"
          />

          <label for="zip" class="form-label">Postal code:</label>
          <input
            class="form-control"
            type="text"
            name="zip"
            v-model="form.zip"
          />

          <label for="phone" class="form-label">Phone Number:</label>
          <input
            class="form-control"
            type="text"
            name="phone"
            v-model="form.phone"
          />

          <label for="fax" class="form-label">Fax Number:</label>
          <input
            class="form-control"
            type="text"
            name="fax"
            v-model="form.fax"
          />

          <label for="text" class="form-label">Email address:</label>
          <input
            class="form-control"
            type="text"
            name="email"
            v-model="form.email"
          />
        </div>

        <div class="col-md-12 col-lg-5">
          <div class="">
            <label class="form-check-label" for="giftcard"
              >Manual Gift Card</label
            >
            <b-form-checkbox
              name="giftcard"
              size="lg"
              v-model="form.giftcard"
              :value="1"
              :unchecked-value="0"
              switch
            />
          </div>

          <div>
            <label class="form-check-label" for="amway">Amway Supplier</label>
            <b-form-checkbox
              name="giftcard"
              size="lg"
              v-model="form.amway"
              :value="true"
              :unchecked-value="false"
              switch
            />
          </div>
          <div class="mt-1">
            <label class="form-check-label" for="excdynamicvendor"
              >Exclude Dynamic Vendor</label
            >
            <b-form-checkbox
              name="giftcard"
              size="lg"
              v-model="form.excdynamicvendor"
              :value="1"
              :unchecked-value="0"
              switch
            />
          </div>
          <div class="mt-1">
            <label class="form-check-label" for="showsuppaddprdinfo"
              >Show Additional Product Info</label
            >
            <b-form-checkbox
              name="giftcard"
              size="lg"
              v-model="form.showsuppaddprdinfo"
              :value="1"
              :unchecked-value="0"
              switch
            />
          </div>
          <div class="mt-1">
            <label for="suppaddprdinfotitle" class="form-label"
              >Show Additional Product Title:</label
            >
            <input
              class="form-control"
              type="text"
              name="suppaddprdinfotitle"
              v-model="form.suppaddprdinfotitle"
            />

            <label for="suppaddprdinfodesc" class="form-label"
              >Show Additional Product Description:</label
            >
            <textarea
              class="form-control"
              name="suppaddprdinfodesc"
              rows="5"
              v-model="form.suppaddprdinfodesc"
            ></textarea>
          </div>
        </div>
      </div>
    </form>
    <div class="row mt-2">
      <div class="col-md-12">
        <input
          type="submit"
          class="btn btn-primary"
          value="Save"
          @click="onSubmit"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "addSuppliersForm",
  data() {
    return {
      form: {
        name: "",
        contact: "",
        accountnum: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        phone: "",
        fax: "",
        email: "",
        giftcard: 0,
        amway: true,
        excdynamicvendor: 1,
        showsuppaddprdinfo: 1,
        suppaddprdinfotitle: "",
        suppaddprdinfodesc: "",
      },
    };
  },
  methods: {
    ...mapActions(["manageSuppliers/addSupplier"]),
    onSubmit(e) {
      e.preventDefault();
      this.form.name = this.form.name.trim();
      this.$store.dispatch("manageSuppliers/addSupplier", this.form);
      this.$router.push({
        name: "ManageSuppliers",
      });
    },
  },
};
</script>
<style scoped>
form {
  border: 1px solid #ccc;
  padding: 20px;

  border-radius: 5px;
}

form label {
  font-size: 15px;
  font-weight: bold;
}

.form-label,
.form-check-label {
  margin-top: 10px;
}

.form-group {
  margin-bottom: 15px;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
}

.form-check {
  padding-left: 2rem !important;
}
</style>
